// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Email_breadcrumb__1akkl"};